module.exports = "<ul>\n  <li *ngFor=\"let d of dates\" [className]=\"classFor(d)\">\n     <a [routerLink]=dayUrl(d) routerLinkActive=\"active\"><span class=\"name\">{{ dayName(d) }}</span><span class=\"indicator\" *ngIf=\"!isToday(d); else todayBlock\">{{ d.getDate() }} {{ shortMonthName(d) }}</span></a>\n  </li>\n</ul>\n<ng-template #todayBlock>Today</ng-template>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/cal/WeekPicker.component.html
// module id = ../../../../../src/app/cal/WeekPicker.component.html
// module chunks = main